import React, { useContext, useState } from 'react';
import PageLayout from '../../pagelayout';
import Dropdown from '../../components/input/dropdown';
import { useLoader } from '../../api/useLoader';
import { AdminApiContext } from '../../api/AdminApiContext';
import Spinner from '../../components/spinner/spinner';
import * as css from './addStudiestedbruker.module.scss';
import Button from '../../components/button';
import { NotificationFunctionContext } from '../../components/notifications/notificationProvider';
import useAddErrorNotificationCallback from '../../hooks/useAddErrorNotificationCallback';
import translations from './addStudiestedbruker.i18n';
import { useFormatMessageFor } from '../../i18n/translation';

const AddStudiestedbrukerPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { brukerApi } = useContext(AdminApiContext);
  const { addSuccessNotification } = useContext(NotificationFunctionContext);

  const { data, loading, reload } = useLoader(
    () =>
      brukerApi.institusjonerGet({ queryParams: { withoutPrevAccess: true } }),
    [],
  );
  const errorNotificationCallback = useAddErrorNotificationCallback();

  const [chosenInstitusjonId, setChosenInstitusjonId] = useState<string>();
  const labels = useFormatMessageFor(translations);

  if (loading) return <Spinner />;
  if (!data) return <></>;

  const { institusjoner } = data;

  const submitUser = () => {
    if (!chosenInstitusjonId) return;

    brukerApi
      .studiestedbrukerStudiestedIdPost({
        pathParams: { studiestedId: chosenInstitusjonId },
      })
      .then(() => {
        addSuccessNotification(labels.successMsg);
        reload();
      })
      .catch(errorNotificationCallback);
  };

  return (
    <PageLayout title={labels.title} subtitle={labels.subtitle} isIndented>
      <div className={css.content}>
        <Dropdown
          id={'institusjoner-dropdown'}
          onChange={(_, value) => setChosenInstitusjonId(value.id)}
          label={labels.institutionLabel}
          placeholder={labels.placeholder}
          options={institusjoner.map((institusjon) => ({
            id: institusjon.studiestedId,
            navn: institusjon.navn,
            institusjonsnr: institusjon.institusjonsnr,
          }))}
          renderOption={(option) => (
            <PadInstitusjonsnrNavn
              institusjonsnr={option.institusjonsnr}
              navn={option.navn}
            />
          )}
        />
        <Button.Secondary
          disabled={!chosenInstitusjonId}
          className={css.submitBtn}
          onClick={submitUser}
        >
          {labels.btnText}
        </Button.Secondary>
      </div>
    </PageLayout>
  );
};

const PadInstitusjonsnrNavn: React.FC<
  React.PropsWithChildren<{
    institusjonsnr: string;
    navn: string;
  }>
> = ({ institusjonsnr, navn }) => (
  <>
    <span className={css.institusjonsnr}>{institusjonsnr}</span>
    <span className={css.navn}>{navn}</span>
  </>
);

export default AddStudiestedbrukerPage;
